import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const LoanAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/solusi-masa-depan-anda/pinjaman${props}`,
    {
      headers
    }
  );
};
export default LoanAPI;
